import { createApp } from "vue";
import App from "./App.vue";

// 为避免Cannot read properties of undefined (reading 'globalProperties')
// 需要将crateApp和mount分开，将全局绑定内容夹在中间
const app = createApp(App).use(router).use(Vant).use(ElementPlus);
// .use(VueCropper);

import router from "./router";
import "lib-flexible";
import Vant from "vant";
import "vant/lib/index.css";
import ElementPlus from "element-plus"; //全局引入
import "element-plus/dist/index.css";
// import VueCropper from "vue-cropper";

//注意use要在mount之前
app.mount("#app");
